import * as util from 'util';

/** Wrapper for Node.js promisify */
export const promisify = util.promisify;
